import axios from "axios";
import { AppWindowMac } from "lucide-react";

const BASE_URL = process.env.REACT_APP_API_URL;
const api = axios.create({ baseURL: BASE_URL });

export const getPlans = async () => {
  const response = await api.get(`/api/all-plans`);
  return response.data;
};

export const createPlan = async (data) => {
  const response = await api.post(`/api/create-subscription`, data);
  return response.data;
};

export const updatePlan = async (id, data) => {
  const response = await api.put(`/api/subscription-plans/${id}`, data);
  return response.data;
};

export const deletePlan = async (id) => {
  const response = await api.delete(`/api/subscription-plans/${id}`);
  return response.data;
};

/* --- Countries --- */
export const createCountry = (data) => api.post('/api/countries', data);
export const getCountries = () => api.get('/api/countries');
export const updateCountry = (id, data) => api.put(`/api/countries/${id}`, data);
export const deleteCountry = (id) => api.delete(`/api/countries/${id}`);

/* --- States --- */
export const createState = (data) => api.post('/api/states', data);
export const getStates = () => api.get('/api/states');
export const updateState = (id, data) => api.put(`/api/states/${id}`, data);
export const deleteState = (id) => api.delete(`/api/states/${id}`);

/* --- Cities --- */
export const createCity = (data) => api.post('/api/cities', data);
export const getCities = () => api.get('/api/cities');
export const updateCity = (id, data) => api.put(`/api/cities/${id}`, data);
export const deleteCity = (id) => api.delete(`/api/cities/${id}`);

/* --- Religions --- */
export const createReligion = (data) => api.post('/api/religions', data);
export const getReligions = () => api.get('/api/religions');
export const updateReligion = (id, data) => api.put(`/api/religions/${id}`, data);
export const deleteReligion = (id) => api.delete(`/api/religions/${id}`);

/* --- Castes --- */
export const createCaste = (data) => api.post('/api/castes', data);
export const getCastes = () => api.get('/api/castes');
export const updateCaste = (id, data) => api.put(`/api/castes/${id}`, data);
export const deleteCaste = (id) => api.delete(`/api/castes/${id}`);

/* --- Mother Tongues --- */
export const createMotherTongue = (data) => api.post('/api/mother-tongues', data);
export const getMotherTongues = () => api.get('/api/mother-tongues');
export const updateMotherTongue = (id, data) => api.put(`/api/mother-tongues/${id}`, data);
export const deleteMotherTongue = (id) => api.delete(`/api/mother-tongues/${id}`);

/* --- Education --- */
export const createEducation = (data) => api.post('/api/education', data);
export const getEducations = () => api.get('/api/education');
export const updateEducation = (id, data) => api.put(`/api/education/${id}`, data);
export const deleteEducation = (id) => api.delete(`/api/education/${id}`);

/* --- Gothrams --- */
export const createGothram = (data) => api.post('/api/gothrams', data);
export const getGothrams = () => api.get('/api/gothrams');
export const updateGothram = (id, data) => api.put(`/api/gothrams/${id}`, data);
export const deleteGothram = (id) => api.delete(`/api/gothrams/${id}`);

/* --- Dhoshams --- */
export const createDhosham = (data) => api.post('/api/dhosams', data);
export const getDhoshams = () => api.get('/api/dhosams');
export const updateDhosham = (id, data) => api.put(`/api/dhosams/${id}`, data);
export const deleteDhosham = (id) => api.delete(`/api/dhosams/${id}`);

/* --- Occupations --- */
export const createOccupation = (data) => api.post('/api/occupations', data);
export const getOccupations = () => api.get('/api/occupations');
export const updateOccupation = (id, data) => api.put(`/api/occupations/${id}`, data);
export const deleteOccupation = (id) => api.delete(`/api/occupations/${id}`);

export const createZodiac = (data) => api.post('/api/zodiac-signs', data);
export const getZodiac = () => api.get('/api/zodiac-signs');
export const updateZodiacSign = (id, data) => api.put(`/api/zodiac-signs/${id}`, data);
export const deleteZodiacSign = (id) => api.delete(`/api/zodiac-signs/${id}`);

export const createStar = (data) => api.post('/api/stars', data);
export const getStar = () => api.get('/api/stars');
export const updateStar = (id, data) => api.put(`/api/stars/${id}`, data);
export const deleteStar = (id) => api.delete(`/api/stars/${id}`);

export const getProfiles = async () => {
  try {
    const response = await api.get('/api/matrimony/admin-profiles');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching profiles:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch profiles');
  }
};

export const updateProfileStatus = async (id, action) => {
  const response = await api.post(`api/profiles/${id}/status`, {
    action,
  });
  return response.data.data;
};

export const fetchForms = async () => {
  try {
    const response = await api.get('/api/forms');
    return response.data;
  } catch (error) {
    console.error('Error fetching forms:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch forms');
  }
};

export const createForm = async (data) => {
  try {
    const response = await api.post('/api/forms', data);
    return response.data;
  } catch (error) {
    console.error('Error creating form:', error);
    throw new Error(error.response?.data?.error || 'Failed to create form');
  }
};

export const fetchFormDetails = async (formId) => {
  try {
    const response = await api.get(`/api/forms/${formId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching form details:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch form details');
  }
};

export const createFormField = async (data) => {
  try {
    const response = await api.post('/api/form-fields', data);
    return response.data;
  } catch (error) {
    console.error('Error creating form field:', error);
    throw new Error(error.response?.data?.error || 'Failed to create form field');
  }
};

export const createFieldOption = async (data) => {
  try {
    const response = await api.post('/api/form-field-options', data);
    return response.data;
  } catch (error) {
    console.error('Error creating field option:', error);
    throw new Error(error.response?.data?.error || 'Failed to create field option');
  }
};

export const deleteForm = async (id) => {
  try {
    await api.delete(`/api/forms/${id}`);
  } catch (err) {
    console.error('Error deleting form:', err);
    throw new Error(err.response?.data?.error || 'Failed to delete form');
  }
};

export async function updateFieldOrder(formId, fields) {
  try {
    const res = await api.put(
      `/api/${formId}/fields/order`,
      { fields }
    );
    return res.data;
  } catch (err) {
    throw new Error(err)
  }
}

export const updateFormField = async (id, data) => {
  try {
    const res = await api.put(`/api/form-fields/${id}`, data);
    return res.data;
  } catch (error) {
    console.error('Error updating form field:', error);
    throw new Error(error.response?.data?.error || 'Failed to update form field');
  }
};

export const deleteFormField = async (id) => {
  try {
    const res = await api.delete(`/api/form-fields/${id}`);
    return res.data;
  } catch (error) {
    console.error('Error deleting form field:', error);
    throw new Error(error.response?.data?.error || 'Failed to delete form field');
  }
};

export const updateForm = async (id, data) => {
  try {
    const response = await api.put(`/api/forms/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating form:', error);
    throw new Error(error.response?.data?.error || 'Failed to update form');
  }
};

export const getCaFormResponses = async (formId) => {
  try {
    const res = await api.get(`/api/caforms/${formId}/responses`);
    return res.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || `Error fetching responses for form ${formId}: ${error.message}`);
  }
};

export async function getCaFormById(formId) {
  try {
    const response = await api.get(`/api/caforms/${formId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || `Error fetching form ${formId}: ${error.message}`);
  }
}

export const verifyKycAPI = async (founderId) => {
  return api.patch(
    `/api/founder-kyc/${founderId}/status`,
    { verification_status: 'approved' }
  );
};

export async function getEarningsDashboard() {
  try {
    const response = await api.get('/api/fundings/earnings');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message);
  }
}

export const getGateways = async () => {
  try {
    const res = await api.get('/api/payment-gateways');
    return res.data;
  } catch (error) {
    console.error('Error fetching payment gateways:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch payment gateways');
  }
};

export const createGateway = async (data) => {
  try {
    const res = await api.post('/api/payment-gateways', data);
    return res.data;
  } catch (error) {
    console.error('Error creating payment gateway:', error);
    throw new Error(error.response?.data?.error || 'Failed to create payment gateway');
  }
};

export const updateGateway = async (id, data) => {
  try {
    const res = await api.put(`/api/payment-gateways/${id}`, data);
    return res.data;
  } catch (error) {
    console.error('Error updating payment gateway:', error);
    throw new Error(error.response?.data?.error || 'Failed to update payment gateway');
  }
};

export const deleteGateway = async (id) => {
  try {
    const res = await api.delete(`/api/payment-gateways/${id}`);
    return res.data;
  } catch (error) {
    console.error('Error deleting payment gateway:', error);
    throw new Error(error.response?.data?.error || 'Failed to delete payment gateway');
  }
};

/* --- Tickets --- */
export const getTickets = async (status = '') => {
  try {
    const url = status ? `/api/tickets?status=${status}` : '/api/tickets';
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching tickets:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch tickets');
  }
};

export const updateTicket = async (id, data) => {
  try {
    const response = await api.put(`/api/tickets/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating ticket:', error);
    throw new Error(error.response?.data?.error || 'Failed to update ticket');
  }
};

export const deleteTicket = async (id) => {
  try {
    const response = await api.delete(`/api/tickets/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting ticket:', error);
    throw new Error(error.response?.data?.error || 'Failed to delete ticket');
  }
};

export const getStaticOption = async (key) => {
  try {
    const response = await api.get('/api/static-options', { params: { key } });
    return response.data.value;
  } catch (error) {
    console.error(`Failed to get static option [${key}]:`, error);
    throw error;
  }
};

export const setStaticOption = async (key, value) => {
  try {
    const response = await api.post('/api/static-options', { key, value });
    return response.data;
  } catch (error) {
    console.error(`Failed to set static option [${key}]:`, error);
    throw error;
  }
};

export const getAllDocumentation = async () => {
  try {
    const response = await api.get(`/api/documentation`);
    return response.data.documentation;
  } catch (error) {
    console.error('Error fetching documentation:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch documentation');
  }
};

export const getDocumentationById = async (id) => {
  try {
    const response = await api.get(`/api/documentation/${id}`);
    return response.data.documentation;
  } catch (error) {
    console.error('Error fetching documentation by ID:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch documentation');
  }
};

export const deleteDocumentation = async (id) => {
  try {
    const response = await api.delete(`/api/documentation/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting documentation:', error);
    throw new Error(error.response?.data?.error || 'Failed to delete documentation');
  }
};

export const getDynamicFields = async () => {
  try {
    const { data } = await api.get('/api/dynamic-fields');
    return data;
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch dynamic fields');
  }
};

export const createDynamicField = async (fieldData) => {
  try {
    const data = await api.post('/api/dynamic-fields', fieldData);
    return data;
  } catch (error) {
    throw new Error(error.message || 'Failed to create dynamic field');
  }
};

export const toggleDynamicFieldStatus = async (fieldId) => {
  try {
    const data = await api.patch(`/api/dynamic-fields/${fieldId}/toggle`);
    return data;
  } catch (error) {
    throw new Error(error.message || 'Failed to toggle field status');
  }
};

export const deleteDynamicField = async (fieldId) => {
  try {
    await api.delete(`/api/dynamic-fields/${fieldId}`);
  } catch (error) {
    throw new Error(error.message || 'Failed to delete dynamic field');
  }
};

export const getSectorContacts = async () => {
  try {
    const response = await api.get('/api/sector-contacts');
    return response.data;
  } catch (error) {
    console.error('Error fetching sector contacts:', error);
    throw error;
  }
};

export const getContactsBySector = async (sector) => {
  try {
    const response = await api.get(`/api/sector-contacts/${sector}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sector contacts:', error);
    throw error;
  }
};

// Update your API function to send the correct field name
export const saveSectorContacts = async (sector, phoneNumbers) => {
  try {
    const response = await api.post('/api/sector-contacts', {
      sector,
      phoneNumbers
    });
    return response.data;
  } catch (error) {
    console.error('Error saving sector contacts:', error);
    throw error;
  }
};

export const deleteSectorContacts = async (sector) => {
  try {
    const response = await api.delete(`/api/sector-contacts/${sector}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting sector contacts:', error);
    throw error;
  }
};

export const updatePaymentStatus = async (startupId, paymentData) => {
  try {
    const response = await api.put(
      `/api/startups/payment-status/${startupId}`,
      paymentData
    );
    return response.data;
  } catch (error) {
    console.error('Error updating payment status:', error);
    throw error;
  }
};

export const toggleStartupStatus = async (startupId, action) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/api/startups/${action}/${startupId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('Startuptoken')}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error toggling startup status (${action}):`, error);
    throw error;
  }
};

export const getMentors = async () => {
  const res = await api.get("/api/mentors");
  const raw = Array.isArray(res.data) ? res.data : res.data?.mentors || res.data?.data || [];
  return raw.map((m) => ({
    ...m,
    active: (m.isActive === 1 || m.isActive === "1") ? true : !!m.active,
    phone: m.number || m.phone || "",
    linkedin: m.linkedinProfile || m.linkedin || "",
    profileImage: m.image || m.profileImage || "",
  }));
};

// Create a new mentor
export const createMentor = async (mentorData) => {
  const res = await api.post("/api/mentors", mentorData, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

// Update an existing mentor
export const updateMentor = async (id, mentorData) => {
  const res = await api.put(`/api/mentors/${id}`, mentorData, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

// Delete a mentor
export const deleteMentor = async (id) => {
  const res = await api.delete(`/api/mentors/${id}`);
  return res.data;
};

// Toggle mentor status (active/inactive)
export const toggleMentorStatus = async (id, newStatus) => {
  const res = await api.put(`/api/mentors/${id}`, { isActive: newStatus }, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

// ---------- Mentor Requests API ----------

// Fetch requests for a specific mentor
export const getMentorRequests = async (mentorId) => {
  const res = await api.get(`/api/mentor-requests/mentor/${mentorId}`);
  const data = Array.isArray(res.data) ? res.data : res.data?.requests || res.data?.data || [];
  return data;
};

// ---------- Startups API ----------

// Fetch startup by ID (used for mentor requests)
export const getStartupById = async (startupId) => {
  const res = await api.get(`/api/startups/${startupId}`);
  return res.data;
};

// ---------- Image Upload API ----------

// Upload a profile image
export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append("image", file);

  const res = await api.post("/api/upload/image", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return (
    (res?.data?.url) ||
    (res?.data?.data?.url) ||
    (res?.data?.result?.url) ||
    null
  );
};

export const getCTAs = async () => {
  const res = await api.get("/api/call-to-actions");
  const raw = Array.isArray(res.data) ? res.data : res.data?.ctas || res.data?.data || [];
  return raw.map((c) => ({
    ...c,
    role: c.role || "",
    number: c.number || "",
  }));
};

export const createCTA = async (ctaData) => {
  const res = await api.post("/api/call-to-actions", ctaData, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const updateCTA = async (id, ctaData) => {
  const res = await api.put(`/api/call-to-actions/${id}`, ctaData, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const editCTA = async (id, ctaData) => {
  const res = await api.patch(`/api/call-to-actions/${id}`, ctaData, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const deleteCTA = async (id) => {
  const res = await api.delete(`/api/call-to-actions/${id}`);
  return res.data;
};

export const getCoupons = async (params = {}) => {
  try {
    const res = await api.get('/api/coupons', { params });
    return res.data;
  } catch (error) {
    console.error('Error fetching coupons:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch coupons');
  }
};

export const createCoupon = async (payload) => {
  try {
    const res = await api.post('/api/coupons', payload);
    return res.data;
  } catch (error) {
    console.error('Error creating coupon:', error);
    throw new Error(error.response?.data?.message || 'Failed to create coupon');
  }
};

export const getCouponById = async (id) => {
  try {
    const res = await api.get(`/api/coupons/${id}`);
    return res.data;
  } catch (error) {
    console.error('Error fetching coupon by id:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch coupon');
  }
};

export const bulkCreateCoupons = async (coupons) => {
  try {
    const res = await api.post("/api/coupons/bulk", { coupons });
    return res.data;
  } catch (error) {
    console.error("Error bulk creating coupons:", error);
    throw new Error(error.response?.data?.message || "Failed to import coupons");
  }
};

export const tactosCreateCoupon = async (payload) => {
  try {
    const res = await api.post('/api/create-coupon', payload);
    return res.data;
  } catch (error) {
    console.error('Error creating coupon:', error);
    throw new Error(error.response?.data?.message || 'Failed to create coupon');
  }
};

export const tactosGetCoupons = async () => {
  try {
    const res = await api.get('/api/get-coupons');
    return res.data;
  } catch (error) {
    console.error('Error fetching coupons:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch coupons');
  }
};



export const tactosDeleteCoupon = async (id) => {
  try {
    const res = await api.delete(`/api/get-coupon/${id}`);
    return res.data;
  } catch (error) {
    console.error('Error fetching coupons:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch coupons');
  }
};

// ===============================
// 📌 GET ALL EVENTS
// ===============================
export const fetchTactosEvents = async (filters = {}) => {
  try {
    const res = await api.get(`/api/events`, { params: filters });
    console.log(res)
    return res.data;
  } catch (error) {
    console.error('Error fetching active programs:', error);
    throw error;
  }
};


// ===============================
// 📌 POST (Create Event)
// ===============================
export const tactosCreateEvent = async (payload) => {
  try {
    const res = await api.post(`/api/events`, {
      ...payload,
      createdAt: new Date().toISOString(),
    });
    return res.data;
  } catch (error) {
    console.error("Error Creating Event:", error);
    throw new Error(error.response?.data?.message || "Failed to create event");
  }
};


// ===============================
// 📌 PUT (Update Event)
// ===============================
export const tactosUpdateEvent = async (id, payload) => {
  try {
    const res = await api.put(`/api/events/${id}`, payload);
    return res.data;
  } catch (error) {
    console.error("Error Updating Event:", error);
    throw new Error(error.response?.data?.message || "Failed to update event");
  }
};


// ===============================
// 📌 DELETE (Delete Event)
// ===============================
export const tactosDeleteEvent = async (id) => {
  try {
    const res = await api.delete(`/api/events/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error Deleting Event:", error);
    throw new Error(error.response?.data?.message || "Failed to delete event");
  }
};



// ===============================
// 📌 GET ALL Program
// ===============================
export const fetchTactosPrograms = async () => {
  try {
    const res = await api.get(`/api/program`);
    console.log(res)
    return res.data;
  } catch (error) {
    console.error("Error Fetching Events:", error);
    throw new Error(error.response?.data?.message || "Failed to fetch events");
  }
};


// ===============================
// 📌 POST (Create Event)
// ===============================
export const tactosCreatePrograms = async (payload) => {
  try {
    const res = await api.post(`/api/program`, {
      ...payload,
      createdAt: new Date().toISOString(),
    });
    return res.data;
  } catch (error) {
    console.error("Error Creating program:", error);
    throw new Error(error.response?.data?.message || "Failed to create program");
  }
};


// ===============================
// 📌 PUT (Update Event)
// ===============================
export const tactosUpdatePrograms = async (id, payload) => {
  try {
    const res = await api.put(`/api/program/${id}`, payload);
    return res.data;
  } catch (error) {
    console.error("Error Updating program:", error);
    throw new Error(error.response?.data?.message || "Failed to update program");
  }
};


// ===============================
// 📌 DELETE (Delete Event)
// ===============================
export const tactosDeletePrograms = async (id) => {
  try {
    const res = await api.delete(`/api/program/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error Deleting program:", error);
    throw new Error(error.response?.data?.message || "Failed to delete program");
  }
};

export const tactosDeleteIdea = async (id) => {
  try {
    const res = await api.delete(`/api/ideas/delete/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error Deleting program:", error);
    throw new Error(error.response?.data?.message || "Failed to delete program");
  }
};

// Forums

export const getAllForums = async () => {
  try {
    const res = await api.get(`/api/getAllForums`);
    return res.data;
  } catch (error) {
    console.error("Error Fetching Forums:", error);
    throw new Error(error.response?.data?.message || "Failed to Fetch Forums");
  }
};

export const createForum = async (data) => {
  try {
    const bearer = localStorage.getItem("admintoken")
    const res = await api.post(`/api/createforum`, data, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      }
    },);
    console.log(res)
    return res.data;
  } catch (error) {
    console.error('Error Creating Forums:', error);
    throw error;
  }
};

export const deleteForum = async (id) => {
  try {
    const bearer = localStorage.getItem("admintoken")
    const res = await api.delete(`/api/deleteforums/${id}`, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      }
    });
    console.log(res)
    return res.data;
  } catch (error) {
    console.error('Error Deleteing Forums:', error);
    throw error;
  }
};
export const updateForum = async (id, data) => {
  try {
    const bearer = localStorage.getItem("admintoken")
    const res = await api.put(`/api/updateforums/${id}`, data, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      }
    });
    return res.data;
  } catch (error) {
    console.error('Error updating Forums:', error);
    throw error;
  }
};
export const updateForumStatus = async (id, data) => {
  try {
    const bearer = localStorage.getItem("admintoken")
    const res = await api.patch(`/api/updateforums/status/${id}`, data, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      }
    });
    return res.data;
  } catch (error) {
    console.error('Error updating Forums status:', error);
    throw error;
  }
};
export const removeComment = async (forumId, commentId) => {
  try {
    const bearer = localStorage.getItem("admintoken")
    const res = await api.delete(`/api/forums/comment/${forumId}/${commentId}`, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      }
    });
    return res.data;
  } catch (error) {
    console.error('Error adding Comments:', error);
    throw error;
  }
};


export const getAllStartups = async () => {
  try {
    const bearer = localStorage.getItem("admintoken")
    const res = await api.get(`/api/startups`, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      }
    });
    return res.data;
  } catch (error) {
    console.error("Error Fetching Startups:", error);
    throw new Error(error.response?.data?.message || "Failed to Fetch Forums");
  }
};
export const getAllPitchdecks = async () => {
  try {
    const res = await api.get(`/api/pitchdeck`);
    return res.data;
  } catch (error) {
    console.error("Error Fetching alldecks:", error);
    throw new Error(error.response?.data?.message || "Failed to Fetch Forums");
  }
};

export const deletePitchdeck = async (pitchdeckid) => {
  try {
    const bearer = localStorage.getItem("admintoken")
    const res = await api.delete(`/api/deletepitchdeck/${pitchdeckid}`, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      }
    });
    return res.data;
  } catch (error) {
    console.error("Error Deleteing Pitchdeck:", error);
    throw new Error(error.response?.data?.message || "Failed to Delete pitchdeck");
  }
};
export const getCommission = async () => {
  try {
    const bearer = localStorage.getItem("admintoken")
    const res = await api.get(`/api/commission`, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      }
    });
    return res.data;
  } catch (error) {
     if (error.response?.status === 401) {
      localStorage.clear(); // or remove only admin token
      window.location.href = "/login"; // redirect
    }
    console.error("Error Fetching Commission:", error);
    throw new Error(error.response?.data?.message || "Failed to Fetch Forums");
  }
};
export const updateCommission = async (data) => {
  try {
    const bearer = localStorage.getItem("admintoken")
    const res = await api.post(`/api/commission`,data, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      }
    });
    return res.data;
  } catch (error) {
     if (error.response?.status === 401) {
      localStorage.clear(); // or remove only admin token
      window.location.href = "/login"; // redirect
    }
    console.error("Error updating Commission:", error);
    throw new Error(error.response?.data?.message || "Failed to Fetch Forums");
  }
};


export const getAppointmentTransactions= async () => {
  try {
    const bearer = localStorage.getItem("admintoken")
    const res = await api.get(`/api/admin/transactions`, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      }
    });
    return res.data;
  } catch (error) {
     if (error.response?.status === 401) {
      localStorage.clear(); 
      window.location.href = "/login";
    }
    console.error("Error Fetching AppointmentTransactions:", error);
    throw new Error(error.response?.data?.message || "Failed to AppointmentTransactions");
  }
}
export const getAppointments= async () => {
  try {
    const bearer = localStorage.getItem("admintoken")
    const res = await api.get(`/api/admin/allbookings`, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      }
    });
    return res.data;
  } catch (error) {
     if (error.response?.status === 401) {
      localStorage.clear(); 
      window.location.href = "/login";
    }
    console.error("Error Fetching AppointmentTransactions:", error);
    throw new Error(error.response?.data?.message || "Failed to AppointmentTransactions");
  }
}

// getall payouts
export const getAllPayoutRequests= async () => {
  try {
    const bearer = localStorage.getItem("admintoken")
    const res = await api.get(`/api/admin/payout/request`, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      }
    });
    return res.data;
  } catch (error) {
     if (error.response?.status === 401) {
      localStorage.clear(); 
      window.location.href = "/login";
    }
    console.error("Error Fetching allpayouts:", error);
    throw new Error(error.response?.data?.message || "Failed to allpayouts");
  }
}


export const updatePayoutStatus = async (payoutId,data) => {
  try {
    const bearer = localStorage.getItem("admintoken")
    const res = await api.patch(`api/admin/payout/request/${payoutId}`,data, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      }
    });
    return res.data;
  } catch (error) {
     if (error.response?.status === 401) {
      localStorage.clear(); // or remove only admin token
      window.location.href = "/login"; // redirect
    }
    console.error("Error updating Payout Status:", error);
    throw new Error(error.response?.data?.message || "Failed to  updating Payout Status");
  }
};